import { render, staticRenderFns } from "./PNDiagnosisList.vue?vue&type=template&id=4a509305"
import script from "./PNDiagnosisList.vue?vue&type=script&lang=js"
export * from "./PNDiagnosisList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports